import { render, staticRenderFns } from "./BaseMenu.vue?vue&type=template&id=2c32c920&scoped=true&"
import script from "./BaseMenu.vue?vue&type=script&lang=js&"
export * from "./BaseMenu.vue?vue&type=script&lang=js&"
import style0 from "./BaseMenu.vue?vue&type=style&index=0&id=2c32c920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c32c920",
  null
  
)

export default component.exports